import { createSlice } from "@reduxjs/toolkit";


const initialState = {
  mode: "dark",
  userId: null,
  user: null,
  token: null,
  bookings: null,
}

export const authSlice  = createSlice({
  name: "auth",
  initialState,
  reducers: {
      setMode: (state) => {
          state.mode = state.mode === "light" ? "dark" : "light";
      },
      setLogin: ( state, action ) => {
          state.userId = action.payload.userId;
          state.token = action.payload.token;
      },
      setLogout: ( state ) => {
          state.userId = null;
          state.token = null;
      },
      setBookings: (state, action) => {
          state.bookings = action.payload.bookings;
      },
      setBooking: (state, action) => {
          const updatedBooking = state.bookings.map((booking) => {
              if (booking._id === action.payload.booking_id) {
                  return action.payload.booking;
              }
              return booking;
          })
          state.bookings = updatedBooking;
      }
  }
});

export const { setMode, setLogin, setLogout, setBookings, setBooking } = authSlice.actions;
export default authSlice.reducer;